import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { useTheme } from '../hooks/useTheme';

const NoticeDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [notice, setNotice] = useState(null);
  const { theme } = useTheme();

  useEffect(() => {
    // TODO: Replace with actual API call
    const notices = [
      {
        id: '1',
        title: '[Notice] Fansign Event for Juicy Luicy New Album',
        date: '2024-06-01',
        preview: 'Join our fansign event for the new album! Check details inside.',
        content: 'Full details about the fansign event for Juicy Luicy...'
      },
      {
        id: '2',
        title: '[Notice] Merch Pre-order Open!',
        date: '2024-05-20',
        preview: 'Official Juicy Luicy merch pre-order is now open. Limited stock!',
        content: 'Full details about the merch pre-order...'
      },
      {
        id: '3',
        title: '[Notice] Concert Announcement',
        date: '2024-05-10',
        preview: 'Juicy Luicy will be performing live in Jakarta. Get your tickets!',
        content: 'Full details about the concert...'
      }
    ];
    const foundNotice = notices.find(n => n.id === id);
    setNotice(foundNotice);
  }, [id]);

  if (!notice) return <div className={`p-8 ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>Notice not found.</div>;

  return (
    <div className={`min-h-screen bg-gradient-to-br ${theme === 'dark' ? 'from-gray-900 to-gray-800' : 'from-gray-50 to-gray-200'} p-8`}>
      <div className={`max-w-3xl mx-auto ${theme === 'dark' ? 'bg-gray-800/90' : 'bg-white/90'} rounded-2xl shadow-lg p-8`}>
        <button
          onClick={() => navigate(-1)}
          className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 hover:shadow-button-hover hover:-translate-y-0.5 inline-flex items-center gap-2 mb-8 ${
            theme === 'dark' 
              ? 'bg-gradient-secondary text-white' 
              : 'bg-primary text-white'
          }`}
        >
          <FaArrowLeft /> Back
        </button>

        <h1 className={`text-3xl font-bold mb-4 ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>
          {notice.title}
        </h1>

        <div className={`text-sm mb-8 pb-4 border-b ${theme === 'dark' ? 'text-gray-300 border-gray-600' : 'text-dark-lighter border-gray-200'}`}>
          {notice.date}
        </div>

        <div className={`text-lg leading-relaxed whitespace-pre-wrap ${theme === 'dark' ? 'text-gray-200' : 'text-dark'}`}>
          {notice.content}
        </div>
      </div>
    </div>
  );
};

export default NoticeDetailPage; 